import { SIGNOUT_SUCCESS } from 'store/modules/network';
import { fetchGet, fetchPost, fetchPatch, fetchPut, fetchDelete } from 'services/http';

export const authFetchGet = (endpoint, dispatch, params) => authFetch(fetchGet(endpoint, null, params), dispatch);

export const authFetchPost = (endpoint, dispatch, body, params) =>
  authFetch(fetchPost(endpoint, body, null, params), dispatch);

export const authFetchPatch = (endpoint, dispatch, body, params) =>
  authFetch(fetchPatch(endpoint, body, null, params), dispatch);

export const authFetchPut = (endpoint, dispatch, body, params) =>
  authFetch(fetchPut(endpoint, body, null, params), dispatch);

export const authFetchDelete = (endpoint, dispatch, params) => authFetch(fetchDelete(endpoint, null, params), dispatch);

const authFetch = (promise, dispatch) =>
  promise.then(response => {
    if (response.status === 401) {
      handleUnauthorized(dispatch);
    }
    return response;
  });

export const handleUnauthorized = dispatchFunction => {
  dispatchFunction(signoutImmediately());
};

/**
 * Call this method when signing out the user due to a 401 (Unauthorized) response.
 * Immediately set the authorized state to false without calling the /logout
 * endpoint, thus redirecting the user to /login.
 */
export const signoutImmediately = () => {
  return { type: SIGNOUT_SUCCESS };
};
